export default __webpack_public_path__ + "static/media/success-student-invitation.01a068f1.svg";